import { Actions } from './clientActions';

/**
 * Etat initial
 */
const initialState = {
    suggestions: {
        items: [],
        isLoading: false,
        value: '',
        selectedId: 0,
        chargerContact: false,
        chargerContactExclusionMotif: 0
    },
    contacts: {
        items: [],
        isLoading: false,
        selectedId: 0
    }
};

/**
 * Reducer pour le domaine "client"
 */
const reducer = (namespace) => (state = initialState, action) => {

    switch (action.type) {
        case `${namespace}/${Actions.FETCH_SUGGESTIONS_CLIENT_REQUEST}`:
            return {
                ...state,
                suggestions: { ...state.suggestions, isLoading: true }
            };
        case `${namespace}/${Actions.FETCH_SUGGESTIONS_CLIENT_SUCCESS}`:
            return {
                ...state,
                suggestions: { ...state.suggestions, items: [...action.clients], isLoading: false }
            };
        case `${namespace}/${Actions.FETCH_SUGGESTIONS_CLIENT_FAILURE}`:
            return {
                ...state,
                suggestions: { ...state.suggestions, isLoading: false, error: action.error }
            };
        case `${namespace}/${Actions.CLEAR_SUGGESTIONS_CLIENT}`:
            return {
                ...state,
                suggestions: { ...state.suggestions, items: [], isLoading: false }
            };
        case `${namespace}/${Actions.SET_CLIENT_VALUE}`:
            return {
                ...state,
                suggestions: { ...state.suggestions, value: action.value, selectedId: action.selectedId, chargerContact: action.chargerContact, chargerContactExclusionMotif: action.chargerContactExclusionMotif },
                contacts: { ...state.contacts, items: [], selectedId: 0 }
            };
        case `${namespace}/${Actions.CLEAR_CLIENT_VALUE}`:
            return {
                ...state,
                suggestions: { ...state.suggestions, value: '', selectedId: 0 }
            };
        case `${namespace}/${Actions.FETCH_CLIENT_CONTACTS_REQUEST}`:
            return {
                ...state,
                contacts: { ...state.contacts, isLoading: true }
            };
        case `${namespace}/${Actions.FETCH_CLIENT_CONTACTS_SUCCESS}`:
            return {
                ...state,
                contacts: { ...state.contacts, items: [...action.contacts], isLoading: false }
            };
        case `${namespace}/${Actions.FETCH_CLIENT_CONTACTS_FAILURE}`:
            return {
                ...state,
                contacts: { ...state.contacts, isLoading: false, error: action.error }
            };
        case `${namespace}/${Actions.SET_CLIENT_CONTACT}`:
            return {
                ...state,
                contacts: { ...state.contacts, selectedId: action.selectedId }
            };

        default:
    }

    return state;
}

export default reducer;